export default __webpack_public_path__ + "d2e5d902ba174b4be1f12c641419ed2f.png";